import {Button, Col, Form, FormControl, Row, Spinner} from "react-bootstrap";

export default function SchedulerToolbar({
    isLoading,
    onDateOffset,
    onDateSelect,
    onRefresh,
    onSearchTextChange,
    searchText,
    selectedDate,
    statusControls,
}) {
    return (
        <Row className="scheduler-toolbar mb-2">
            {statusControls ? (
                <Col xs={12} lg={12} className="scheduler-toolbar-status">
                    {statusControls}
                </Col>
            ) : null}
            <Col xs={12} lg={10} className="scheduler-toolbar-date-column">
                <div className="scheduler-toolbar-date-controls">
                    <Button
                        disabled={isLoading}
                        variant="outline-secondary"
                        aria-label="Previous day"
                        onClick={() => onDateOffset(-1)}
                    >
                        {"<"}
                    </Button>
                    <Form.Control
                        disabled={isLoading}
                        className="scheduler-toolbar-date-input"
                        type="date"
                        name="date"
                        onChange={(event) => onDateSelect(event.target.value)}
                        value={selectedDate}
                    />
                    <Button
                        disabled={isLoading}
                        variant="outline-secondary"
                        aria-label="Next day"
                        onClick={() => onDateOffset(1)}
                    >
                        {">"}
                    </Button>
                    <Button
                        disabled={isLoading}
                        variant="outline-secondary"
                        onClick={() => onDateOffset(0)}
                    >
                        Today
                    </Button>
                    <Button
                        className="scheduler-toolbar-refresh"
                        variant="secondary"
                        disabled={isLoading}
                        onClick={onRefresh}
                    >
                        {isLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : "Refresh"}
                    </Button>
                </div>
            </Col>
            <Col xs={12} lg={2} className="scheduler-toolbar-search-column">
                <FormControl
                    disabled={isLoading}
                    value={searchText}
                    onChange={(event) => onSearchTextChange(event.target.value)}
                    type="search"
                    placeholder="Enter Filter Text..."
                    aria-label="Search"
                />
            </Col>
        </Row>
    );
}
